<template>
	<div>
		<ListHeaderComponent :background="background">
			<span slot="title">{{title}}</span>
		</ListHeaderComponent>
		<FiltersComponents></FiltersComponents>
		<EventsComponent></EventsComponent>
		<ContactComponent></ContactComponent>
		<PartnersComponent></PartnersComponent>
	</div>
</template>

<script>
	import ListHeaderComponent from '@/components/ListHeaderComponent'
	import FiltersComponents from '@/components/EventsList/FiltersComponents'
	import EventsComponent from '@/components/EventsList/EventsComponent'
	import ContactComponent from '@/components/ContactComponent'
	import PartnersComponent from '@/components/PartnersComponent'

	export default {
		components: {
			ListHeaderComponent,
			FiltersComponents,
			EventsComponent,
			ContactComponent,
			PartnersComponent
		},
		data () {
			return {
				title: this.$t('events.header'),
				background: 'events'
			}
		},
		methods: {
			scrollTop () {
				this.$scrollTo('body', 1, {})
			}
		},
		created () {
			this.scrollTop()
		}
	}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/EventsList.vue